import React, {useState} from 'react';
import {Grid, Header, Form, Button, Message, Modal, Icon} from "semantic-ui-react";
import QuizAdder from "./QuizAdder";
import ClassLevelModal from "../../../editComponents/ClassLevelModal";

function AddQuizAssignmentComponent(
    {
        handleChange,
        forms,
        createForms,
        handleClearData,
        editAssignment,
        assignment
    }
) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Modal
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                open={open}
                trigger={<Button color='black' style={{marginTop: 5, marginLeft: 5}}>
                    <Icon name='warning'/>
                    Clear Data
                </Button>}
            >
                <Modal.Header>Clear Data</Modal.Header>
                <Modal.Content image>
                    <Modal.Description>
                        <p>
                            You are attempting to clear the data on this page for any of these reasons:<br/><br/>
                            1. You are finished uploading the assignment and want to add a new one.<br/>
                            2. You made a mistake and would like to restart.<br/>
                            3. You have encountered an error on submitting the assignment and would like to start
                            over.<br/>
                            4. If you are editing an assignment and would like to start from scratch.<br/><br/>
                            <b>Are you sure you want to clear the data on this page?</b>

                        </p>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button color='red' onClick={() => {
                        setOpen(false);
                        handleClearData();
                    }}>
                        Yes
                    </Button>
                    <Button
                        content="No"
                        onClick={() => setOpen(false)}
                    />
                </Modal.Actions>
            </Modal>
            <Grid centered={true}>
                {
                    editAssignment ?
                        <Grid.Row>
                            <Header as='h1'>
                                You are editing {assignment} in Translation Practice
                            </Header>
                        </Grid.Row>
                        :
                        <Grid.Row>
                            <Header as='h1' style={{color: 'black'}}>
                                Add Translation Practice Assignment
                            </Header>
                        </Grid.Row>
                }

                <Message color='blue'>
                    <Header as='h2' textAlign='left' color='black'>
                        <h2 style={{color: 'black'}}>
                            Directions:
                        </h2>
                    </Header>
                    <p style={{textAlign: 'left', color: "black"}}>
                        Below, choose the number of questions in your assignment and click "Build Assignment"
                        <br/>
                        Then enter the English and Samoan translation where indicated.
                        <br/>
                        If audio files or pictures are available, you may also upload them.
                        <br/><br/>
                        When entering the Samoan answer it is possible to enter multiple answers by separating them with
                        a
                        semi-colon. Avoid using semi-colons in your sentences for any other purpose.
                        <br/>
                        For example:
                        <br/>
                        <b>
                            ʻAumai le pepa faʻamolemole ; Faʻamolemole ʻaumai le pepa
                        </b>
                        <br/>
                        This means the computer will accept any of the following as valid answers:
                        <br/>
                        <b>
                            ʻAumai le pepa faʻamolemole
                            <br/>
                            Faʻamolemole ʻaumai le pepa
                        </b>
                        <br/><br/>
                        {`If alternative words or phrases are allowable within any given sentence you can indicate them within a pair of < > and each separated by |`}
                        <br/>
                        For example:
                        <br/>
                        <b>
                            {"ʻUa fiafia < maua | matou | tatou>"}
                        </b>
                        <br/>

                        Here maua, matou, tatou are indicated as valid alternatives, which means the computer will
                        accept
                        any of the following as valid answers:
                        <b>
                            <br/>
                            ʻUa fiafia maua
                            <br/>
                            ʻUa fiafia matou
                            <br/>
                            ʻUa fiafia tatou
                        </b>
                    </p>
                </Message>
                <Grid.Row>
                    {
                        editAssignment ?
                            null
                            :
                            <Form>
                                <Form.Field>
                                    <label>Please enter the amount of questions in the assignment</label>
                                    <input onChange={handleChange} type='number' style={{width: 75}}/>
                                    <Button onClick={createForms} style={{marginLeft: 5}} color='blue'>Build
                                        Assignment</Button>
                                </Form.Field>
                            </Form>
                    }


                </Grid.Row>


            </Grid>
        </>

    )
}

export default AddQuizAssignmentComponent
